import {getImage} from '@dazn/lp-web/src/utils/commonUtils';
import {
    IBannerSlider,
    IBannerSlide,
    MobileBannerDesignTypes
} from '@dazn/lp-web/src/types';
import {parseNewLines} from '@dazn/lp-web/src/utils/parseNewLines';
import {buttonProxy} from './button.proxy';
import {rotatingContentItem} from '../utils/rotatingContentItem.proxy';
function isChromeOnIOS() {
    const userAgent = navigator.userAgent;

    // Check if the device is iOS
    const isIOS = /iPhone|iPad|iPod/i.test(userAgent);

    // Check if the browser is Chrome on iOS
    const isChromeIOS = /CriOS/i.test(userAgent);

    // Return true only if both conditions are met
    return isIOS && isChromeIOS;
}
export const getButtonItemId = (action: any) => {
    const {buttonId, bannerEntitlementSetId, buttonTrackingId} = action;
    const baseId =
        buttonId === 'GetStarted'
            ? 'lp_get_started_cta'
            : buttonId === 'LearnMore'
            ? 'lp_learn_more_cta'
            : buttonTrackingId;

    return bannerEntitlementSetId &&
        (buttonId === 'GetStarted' || buttonId === 'LearnMore')
        ? `${bannerEntitlementSetId}_${baseId}`
        : baseId || '';
};

const getBackgroundType = (component: any): 'image' | 'video' | 'none' => {
    if (!component) return 'none';

    return component?.sys?.contentType?.sys?.id === 'VideoAsset'
        ? 'video'
        : 'image';
};
const getIfTagSpecificVideo = (component: any): boolean => {
    if (!component || component?.sys?.contentType?.sys?.id !== 'VideoAsset')
        return false;
    const fields = component?.fields;
    const hasTags = Array.isArray(fields?.tags) && fields?.tags.length > 0;

    if (hasTags) return true;

    return false;
};

export function isLandscape() {
    return window.innerWidth > window.innerHeight;
}

const getVideoURL = (component: any) => {
    if (!component) return;
    return {
        default: component?.fields?.video?.fields?.file?.url,
        mobile:
            component?.fields?.mobileVideo?.fields?.file?.url ??
            component?.fields?.video?.fields?.file?.url
    };
};

export function bannersProxy(component: any): IBannerSlider {
    const componentType = component?.fields?.componentType;

    const banners = component?.fields?.entries?.[0]?.fields?.bannerItems;

    return {
        componentType,
        banners: banners
            ?.map((banner: any) => {
                return {
                    entitlementSetId: banner?.fields?.entitlementSetId,
                    billingPeriod: banner?.fields?.billingPeriod,
                    logo: banner?.fields?.logo?.fields?.file?.url,
                    bannerType: banner?.fields?.bannerType,
                    description: parseNewLines(banner?.fields?.description),
                    disclaimer: banner?.fields?.disclaimer,
                    showCountDownTimer: banner?.fields?.showCountDownTimer,
                    countdownVariant: banner?.fields?.countdownVariant ?? 'V2',
                    hideCountdownZero: banner?.fields?.hideCountdownZero,
                    countdownTime: banner?.fields?.countdownDate,
                    countdownUnits: banner?.fields?.countdownUnits,
                    showPrice: banner?.fields?.showPrice,
                    price: banner?.fields?.price,
                    lableType: banner?.fields?.lableType,
                    mobileBannerDesignType:
                        banner?.fields?.mobileBannerDesignTypes ||
                        MobileBannerDesignTypes.CARD_TYPE,
                    label: banner?.fields?.label,
                    goldenLabel: banner?.fields?.goldenLabel,
                    offerLabel: banner?.fields?.offerLabel,
                    showOfferLabel: banner?.fields?.showOfferLabel,
                    discountPrice: banner?.fields?.discountPrice,
                    tier: banner?.fields?.tier,
                    title: parseNewLines(banner?.fields?.title),
                    disable:
                        banner?.fields?.bannerType === 'PPV' &&
                        banner?.fields?.disable,
                    backgroundImage:
                        getBackgroundType(banner?.fields?.backgroundImage) ===
                            'image' &&
                        getImage(banner?.fields?.backgroundImage),
                    videoUrl:
                        (getBackgroundType(banner?.fields?.backgroundImage) ===
                            'video' &&
                            getVideoURL(banner?.fields?.backgroundImage)) ||
                        '',
                    videoPosterImage: getImage(
                        banner?.fields?.backgroundImage?.fields?.posterImage
                    ),
                    backgroundType:
                        getBackgroundType(banner?.fields?.backgroundImage) ||
                        '',
                    isVideoTagSpecific: getIfTagSpecificVideo(
                        banner?.fields?.backgroundImage
                    ),
                    videoTags:
                        getIfTagSpecificVideo(
                            banner?.fields?.backgroundImage
                        ) === true
                            ? banner?.fields?.backgroundImage?.fields?.tags
                            : [],
                    hideFieldsInMobile: banner?.fields?.hideFieldsInMobile,
                    actions: banner?.fields?.actions
                        ?.filter((action: any) => {
                            return action?.fields?.buttonId?.includes(
                                'WatchPromo_'
                            ) && isChromeOnIOS()
                                ? false
                                : true;
                        })
                        .map((action: any) =>
                            buttonProxy({
                                ...action.fields,
                                bannerEntitlementSetId:
                                    banner?.fields?.entitlementSetId
                            })
                        ),
                    rotatingContentItem: rotatingContentItem(
                        banner?.fields?.rotatingContentItems || []
                    )
                };
            })
            .filter((banner: IBannerSlide) => !banner.disable)
    };
}
